import { renderTableHeader_unstable } from "../TableHeader/renderTableHeader.js";
/**
 * Render the final JSX of DataGridHeader
 */ export const renderDataGridHeader_unstable = (state)=>{
    return renderTableHeader_unstable(state);
};
